export default {
  unsatisfactortory: {
    active: require("./../../../../assets/img/ic_1.png"),
    inactive: require("../../../../assets/img/ic_1_inactive.png"),
  },
  below_average: {
    active: require("./../../../../assets/img/ic_2.png"),
    inactive: require("../../../../assets/img/ic_2_inactive.png"),
  },
  average: {
    active: require("./../../../../assets/img/ic_3.png"),
    inactive: require("../../../../assets/img/ic_3_inactive.png"),
  },
  above_average: {
    active: require("./../../../../assets/img/ic_4.png"),
    inactive: require("../../../../assets/img/ic_4_inactive.png"),
  },
  exceptional: {
    active: require("./../../../../assets/img/ic_5.png"),
    inactive: require("../../../../assets/img/ic_5_inactive.png"),
  },
};
